// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_gsA","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_66R StatelessWorkCardsUpsellModal-styles-cls1_gsA"};